import { showError } from "./errors";
import feedbackSchema from "../schemas/feedback";

const Revalidator = require("revalidator");

const privacyCheckbox = document.getElementById("privacy");

/**
 * @description Проводит валидацию поля через модуль Revalidator, в соответствии с переданной схемой.
 * @param {object} schema
 * @param {string} field
 * @param {string} value
 */
const validateWithRevalidator = (schema, field, value) => {
  if (!schema.properties[field]) {
    return { valid: false, error: "Unexpected field." };
  }

  const newSchema = { properties: { [field]: schema.properties[field] } };
  const result = Revalidator.validate({ [field]: value }, newSchema);

  if (result.errors.length) {
    return { valid: false, errorMessage: result.errors.find(error => error.property === field)?.message };
  }

  return { valid: true };
};

function validateInput(input) {
  const validationResult = validateWithRevalidator(feedbackSchema, input.id, input.value);
  const errorId = `${input.id}-error`;
  if (!validationResult.valid) {
    showError(errorId, validationResult.errorMessage);
  }
  return validationResult.valid;
}

/**
 * Проверяем валидность ввода в поле формы.
 */
function validateInputs() {
  let isValid = true;

  const inputs = document.querySelectorAll(".contact-form__form-field");

  inputs.forEach((input) => {
    if (!validateInput(input)) {
      isValid = false;
    }
  });

  // Проверка согласия с условиями
  if (!privacyCheckbox.checked) {
    privacyCheckbox.classList.add("error");
    isValid = false;
  } else {
    privacyCheckbox.classList.remove("error");
  }

  return isValid;
}

export {
  validateInput,
  validateInputs,
  validateWithRevalidator,
};
